package com.htmlagent.site.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.htmlagent.site.KOFI_URL
import com.htmlagent.site.components.widgets.MAX_REFERENCE_PHOTOS
import com.htmlagent.site.components.widgets.RichText
import com.htmlagent.site.components.widgets.dataUrl
import com.htmlagent.site.components.widgets.PendingPhotos
import com.htmlagent.site.components.widgets.imageFiles
import com.htmlagent.shared.session.ImageUpload
import com.htmlagent.site.components.widgets.TipSide
import com.htmlagent.site.components.widgets.Tooltip
import com.htmlagent.site.components.widgets.copyToClipboard
import com.htmlagent.site.components.widgets.prefersReducedMotion
import com.htmlagent.site.i18n.ActivityStrings
import com.htmlagent.site.i18n.AppLocale
import com.htmlagent.site.i18n.LocalStrings
import com.htmlagent.site.state.chat.Activity
import com.htmlagent.site.state.rememberNarrowScreen
import com.htmlagent.site.state.chat.ArtifactCard
import com.htmlagent.site.state.chat.ChatMessage
import com.htmlagent.site.state.chat.ChatPresenter
import com.htmlagent.site.state.chat.UsageFormat
import com.htmlagent.shared.stream.TurnStage
import com.htmlagent.site.theme.ActivityIconStyle
import com.htmlagent.site.theme.AttachButtonVariant
import com.htmlagent.site.theme.AttachmentErrorStyle
import com.htmlagent.site.theme.AttachmentRemoveVariant
import com.htmlagent.site.theme.AttachmentStripStyle
import com.htmlagent.site.theme.AttachmentThumbStyle
import com.htmlagent.site.theme.MessageImageStyle
import com.htmlagent.site.theme.MessageImagesStyle
import com.htmlagent.site.theme.ActivitySheenStyle
import com.htmlagent.site.theme.ActivitySheenTextStyle
import com.htmlagent.site.theme.ActivityStyle
import com.htmlagent.site.theme.AgentAvatarStyle
import com.htmlagent.site.theme.AgentHeaderStyle
import com.htmlagent.site.theme.AgentMessageStyle
import com.htmlagent.site.theme.AgentNameStyle
import com.htmlagent.site.theme.ArtifactCardHeaderStyle
import com.htmlagent.site.theme.ArtifactCardRowStyle
import com.htmlagent.site.theme.ArtifactCardStyle
import com.htmlagent.site.theme.BriefCallStyle
import com.htmlagent.site.theme.ChatHeaderStyle
import com.htmlagent.site.theme.ChatLogStyle
import com.htmlagent.site.theme.ChatPanelStyle
import com.htmlagent.site.theme.ComposerFieldStyle
import com.htmlagent.site.theme.ComposerHintStyle
import com.htmlagent.site.theme.ComposerInputStyle
import com.htmlagent.site.theme.ComposerStyle
import com.htmlagent.site.theme.DayDividerLineStyle
import com.htmlagent.site.theme.DayDividerStyle
import com.htmlagent.site.theme.EmptyStateStyle
import com.htmlagent.site.theme.GhostButtonVariant
import com.htmlagent.site.theme.Icons
import com.htmlagent.site.theme.KbdStyle
import com.htmlagent.site.theme.MessageActionVariant
import com.htmlagent.site.theme.MessageActionsEndStyle
import com.htmlagent.site.theme.MessageActionsStyle
import com.htmlagent.site.theme.MessageConfirmStyle
import com.htmlagent.site.theme.HistoryCancelButtonVariant
import com.htmlagent.site.theme.HistoryConfirmButtonVariant
import com.htmlagent.site.theme.HistoryConfirmDetailStyle
import com.htmlagent.site.theme.HistoryConfirmStyle
import com.htmlagent.site.theme.HistoryConfirmTitleStyle
import com.htmlagent.site.theme.MessageCancelVariant
import com.htmlagent.site.theme.MessageEditBarStyle
import com.htmlagent.site.theme.MessageEditBoxStyle
import com.htmlagent.site.theme.MessageEditFieldStyle
import com.htmlagent.site.theme.MessageEditHintStyle
import com.htmlagent.site.theme.MessageSaveVariant
import com.htmlagent.site.theme.MessageTurnStyle
import com.htmlagent.site.theme.NoticeStyle
import com.htmlagent.site.theme.Palette
import com.htmlagent.site.theme.MobileSessionTitleStyle
import com.htmlagent.site.theme.MobileSessionLineStyle
import com.htmlagent.site.theme.named
import com.htmlagent.site.theme.PanelCloseVariant
import com.htmlagent.site.theme.PanelTitleStyle
import com.htmlagent.site.theme.PillDotStyle
import com.htmlagent.site.theme.PillStyle
import com.htmlagent.site.theme.SendButtonVariant
import com.htmlagent.site.theme.ShortcutStyle
import com.htmlagent.site.theme.Space
import com.htmlagent.site.theme.StopButtonVariant
import com.htmlagent.site.theme.TipInlineStyle
import com.htmlagent.site.theme.Tokens
import com.htmlagent.site.theme.UsageTokensStyle
import com.htmlagent.site.theme.UserMessageStyle
import com.htmlagent.site.theme.WhatNowLineStyle
import com.htmlagent.site.theme.WhatNowStyle
import com.htmlagent.site.theme.WhatNowTitleStyle
import com.htmlagent.site.theme.labelled
import com.htmlagent.site.theme.offPane
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.icons.ArrowUpIcon
import com.varabyte.kobweb.silk.components.icons.CheckIcon
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLInputElement
import org.jetbrains.compose.web.attributes.AttrsScope
import org.w3c.files.File
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement
import org.w3c.dom.SMOOTH
import org.w3c.dom.AUTO
import org.w3c.dom.NEAREST
import org.w3c.dom.ScrollBehavior
import org.w3c.dom.ScrollIntoViewOptions
import org.w3c.dom.ScrollLogicalPosition
import org.w3c.dom.HTMLTextAreaElement
import org.w3c.dom.events.Event

/**
 * The conversation: header, message thread, activity indicator and composer.
 *
 * It collects its flows in here and not in the screen, so each token recomposes only the chat.
 * The thread follows the end only while the person has not gone back to reread: what is
 * remembered is that intent ([PinnedToEnd]), not the geometry of the moment, because asking
 * "am I near the end?" right after a resize gives the wrong answer.
 *
 * [off] and [onOpenArtifact] are the narrow screen, and both default to the wide one so the
 * landscape workspace passes neither: there the page is already beside the conversation, so
 * there is nothing to hide and nowhere to go.
 */
@Composable
fun ChatPanel(
    presenter: ChatPresenter,
    onSend: (String, List<ImageUpload>) -> Unit,
    onRetry: () -> Unit,
    onCancel: () -> Unit,
    onSharpen: (String) -> Unit,
    off: Boolean = false,
    onOpenArtifact: (() -> Unit)? = null,
    onOpenMenu: (() -> Unit)? = null,
) {
    val t = LocalStrings.current
    val messages by presenter.messages.collectAsState()
    val activity by presenter.activity.collectAsState()
    val sessionId by presenter.currentSessionId.collectAsState()

    var log by remember { mutableStateOf<HTMLElement?>(null) }
    val pinnedToEnd = remember { PinnedToEnd() }

    LaunchedEffect(messages) {
        log?.let { if (pinnedToEnd.active) it.scrollToEnd() }
    }

    DisposableEffect(log) {
        val element = log
        if (element == null) {
            onDispose { }
        } else {
            // The divider and the composer move the end of the thread with no message arriving,
            // and so does the pane coming back on screen: a box that was `display: none` loses
            // its scroll offset, so without the second branch crossing to the page and back
            // would drop whoever was rereading at the top of the conversation.
            val observer = ResizeObserver {
                if (pinnedToEnd.active) element.scrollToEnd() else element.restore(pinnedToEnd)
            }
            observer.observe(element)

            val onScroll: (Event) -> Unit = { pinnedToEnd.check(element) }
            element.addEventListener("scroll", onScroll)

            onDispose {
                observer.disconnect()
                element.removeEventListener("scroll", onScroll)
            }
        }
    }

    Column(
        ChatPanelStyle.toModifier().offPane(off).attrsModifier {
            attr("role", "region")
            attr("aria-label", t.chat.regionLabel)
        },
    ) {
        if (onOpenMenu != null && onOpenArtifact != null) {
            val versions by presenter.versions.collectAsState()
            MobileAppBar(
                onPage = false,
                pageAvailable = versions.isNotEmpty(),
                onOpenMenu = onOpenMenu,
                onShowChat = {},
                onShowPage = onOpenArtifact,
            )
            SessionLine(presenter)
        } else {
            Header(presenter)
        }

        Div(
            ChatLogStyle.toModifier().toAttrs {
                ref { element ->
                    log = element
                    onDispose { log = null }
                }
            },
        ) {
            if (messages.isEmpty()) {
                Column(
                    modifier = EmptyStateStyle.toModifier(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(Space.Xl),
                ) {
                    SpanText(t.chat.emptyState)
                    Button(
                        onClick = { onSharpen("") },
                        modifier = BriefCallStyle.toModifier(),
                        variant = null,
                    ) {
                        Glyph(Icons.Spark, size = Tokens.iconSm.value())
                        SpanText(t.chat.describeForMe)
                    }
                }
            } else {
                DayDivider(presenter)
            }

            val idle = activity == Activity.Idle
            messages.forEachIndexed { index, message ->
                // Keyed by position within the session: deleting or editing only ever cuts the
                // thread's tail, so a message keeps its place, and keeps it when its server id
                // arrives after the turn — keying by that id remounted it and replayed its entrance.
                key(sessionId, index) {
                    Div(
                        MessageTurnStyle.toModifier().toAttrs {
                            if (!message.restored) {
                                attr("data-enter", if (message.author == ChatMessage.Author.USER) "end" else "start")
                            }
                        },
                    ) {
                        when (message.author) {
                            ChatMessage.Author.USER -> UserTurn(
                                message = message,
                                editable = idle && message.id != null,
                                onEdit = { text, kept -> presenter.editMessage(message, text, kept) },
                                onDelete = { presenter.deleteMessage(message) },
                            )

                            ChatMessage.Author.AGENT -> AgentTurn(
                                message = message,
                                last = index == messages.lastIndex && !message.streaming,
                                onRetry = onRetry,
                            )
                        }
                    }
                }
            }

            ActivityIndicator(activity)
        }

        Composer(enabled = activity == Activity.Idle, onSend = onSend, onCancel = onCancel)
    }
}

/**
 * The browser's `ResizeObserver`, which the Kotlin/JS DOM bindings do not ship.
 *
 * The real callback takes two arguments and neither is needed; JavaScript ignores the extra
 * ones.
 */
@Suppress("UnusedPrivateProperty") // External declaration: the parameter is consumed by the browser.
private external class ResizeObserver(callback: () -> Unit) {
    fun observe(target: HTMLElement)
    fun disconnect()
}

/**
 * Whether the thread should keep following the end. Starts `true`: a freshly opened
 * conversation is read from the last message.
 */
private class PinnedToEnd {
    var active: Boolean = true
        private set

    /** Where they had left it, for when the box comes back without the offset it had. */
    var offset: Double = 0.0
        private set

    /** Called from the user's scroll, the only thing that changes their intent. */
    fun check(element: HTMLElement) {
        offset = element.scrollTop
        active = element.scrollHeight - element.scrollTop - element.clientHeight < NEAR_END
    }
}

private fun HTMLElement.scrollToEnd() {
    scrollTop = scrollHeight.toDouble()
}

private fun HTMLElement.restore(pinned: PinnedToEnd) {
    scrollTop = pinned.offset
}

/**
 * Slack for deciding someone is looking at the end: a bit more than one line, because demanding
 * the exact pixel would make the message's own growth enough to stop following it.
 */
/** The artifact card shows its size in KB, which is the unit a person reads. */
private const val BYTES_PER_KB = 1024

private const val NEAR_END = 120

/**
 * The session header.
 *
 * The name comes from the page's `<title>` as soon as the model writes it, so the session stops
 * being called "chat" and takes the name of what is being done in it.
 *
 * It is also where the page is reached from when there is no room to show it alongside: see
 * [onOpenArtifact].
 */
@Composable
private fun Header(presenter: ChatPresenter) {
    val t = LocalStrings.current
    val title by presenter.title.collectAsState()
    val activity by presenter.activity.collectAsState()
    val versions by presenter.versions.collectAsState()

    Row(
        modifier = ChatHeaderStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        H1(PanelTitleStyle.toModifier().toAttrs()) { Text(title ?: t.chat.untitled) }

        Row(
            modifier = Modifier.styleModifier { property("flex-shrink", "0") },
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(Space.Sm),
        ) {
            val working = activity != Activity.Idle
            // `status` is a polite live region: it announces this pill's text when it changes,
            // which is exactly the two moments that matter. Putting one on the reply itself
            // would read every token out loud as it arrives.
            Row(
                PillStyle.toModifier().attrsModifier { attr("role", "status") },
                verticalAlignment = Alignment.CenterVertically,
            ) {
                // The dot never goes alone: the text says the same for anyone who cannot tell hues apart.
                Span(
                    PillDotStyle.toModifier()
                        .color(if (working) Tokens.working.value() else Tokens.muted.value())
                        .margin(right = Space.Sm)
                        .toAttrs { attr("aria-hidden", "true") },
                )
                SpanText(if (working) t.chat.statusWorking else t.chat.statusReady)
            }

            UsagePill(presenter)

            // How many versions there are, with the page beside the chat. On a phone the
            // header is the app bar and its switch; see `MobileAppBar`.
            if (versions.isNotEmpty()) {
                SpanText(t.chat.versionCount(versions.size), PillStyle.toModifier())
            }
        }
    }
}

/**
 * The session on a phone, under the app bar: its name, a dot that says whether it is working and
 * what it has cost so far, in one quiet line.
 *
 * It replaces the header's row of pills, which mixed three shapes and three weights. The status
 * has no word of its own here: the dot carries it, and its label says it for a screen reader.
 */
@Composable
private fun SessionLine(presenter: ChatPresenter) {
    val t = LocalStrings.current
    val title by presenter.title.collectAsState()
    val activity by presenter.activity.collectAsState()
    val usage by presenter.usage.collectAsState()
    val locale by AppLocale.current.collectAsState()
    val working = activity != Activity.Idle

    Row(MobileSessionLineStyle.toModifier(), verticalAlignment = Alignment.CenterVertically) {
        Span(
            PillDotStyle.toModifier()
                .color(if (working) Tokens.working.value() else Tokens.muted.value())
                .toAttrs {
                    attr("role", "status")
                    attr("aria-label", if (working) t.chat.statusWorking else t.chat.statusReady)
                },
        )
        H1(MobileSessionTitleStyle.toModifier().toAttrs()) { Text(title ?: t.chat.untitled) }
        usage?.takeIf { it.turns > 0 }?.let { spent -> SpanText(UsageFormat.cost(spent, locale)) }
    }
}

/**
 * What the session has consumed so far.
 *
 * Nothing at all until a turn has run: a session that has not generated anything did not cost
 * zero, it was never measured, and a "0" would be a claim rather than a reading.
 *
 * Tokens AND money together: the amount alone hides which half of the turn is expensive, and
 * that is the only thing this figure is useful for.
 */
@Composable
private fun UsagePill(presenter: ChatPresenter) {
    val t = LocalStrings.current
    val usage by presenter.usage.collectAsState()
    val locale by AppLocale.current.collectAsState()

    val spent = usage?.takeIf { it.turns > 0 } ?: return

    val tokens = t.chat.usageTokens(UsageFormat.tokens(spent.totalTokens, locale))
    val cost = UsageFormat.cost(spent, locale)
    val detail = listOf(
        t.chat.usageInput(UsageFormat.tokens(spent.inputTokens, locale)),
        t.chat.usageOutput(UsageFormat.tokens(spent.outputTokens, locale)),
        t.chat.usageTurns(spent.turns),
        t.chat.usageEstimate,
    ).joinToString(SEPARATOR)

    // The breakdown goes in the title and not on screen. On a phone even the token count goes:
    // measured at 338px of header, the three labels needed 409 and left the heading at zero width.
    // The label keeps both halves, so nothing is lost to a screen reader.
    Span(
        PillStyle.toModifier()
            .attrsModifier {
                attr("title", detail)
                attr("aria-label", "${t.chat.usageLabel}: $tokens$SEPARATOR$cost")
            }
            .toAttrs(),
    ) {
        SpanText("$tokens$SEPARATOR", UsageTokensStyle.toModifier())
        SpanText(cost)
    }
}

/** Between the halves of a label. A middle dot, not a hyphen: it is not a range. */
private const val SEPARATOR = " \u00b7 "

@Composable
private fun DayDivider(presenter: ChatPresenter) {
    val t = LocalStrings.current
    val time by presenter.startedAt.collectAsState()

    Row(DayDividerStyle.toModifier(), verticalAlignment = Alignment.CenterVertically) {
        HorizontalDivider(DayDividerLineStyle.toModifier())
        SpanText(t.chat.startedToday(time), Modifier.margin(leftRight = Space.Md))
        HorizontalDivider(DayDividerLineStyle.toModifier())
    }
}

/** A user turn: their bubble on the right and, under it, what can be done with it. */
@Composable
private fun UserTurn(
    message: ChatMessage,
    editable: Boolean,
    onEdit: (String, List<Int>) -> Unit,
    onDelete: () -> Unit,
) {
    var editing by remember { mutableStateOf(false) }

    if (editing && editable) {
        EditBubble(
            original = message.text,
            images = message.images,
            onSave = { text, kept -> onEdit(text, kept); editing = false },
            onCancel = { editing = false },
        )
    } else {
        if (message.images.isNotEmpty()) MessageImages(message.images)
        SpanText(message.text, UserMessageStyle.toModifier())
        MessageActions(message.text, editable, end = true, onEdit = { editing = true }, onDelete = onDelete)
    }
}

/** The photos a request was sent with, above its bubble. */
@Composable
private fun MessageImages(images: List<String>) {
    val t = LocalStrings.current.chat
    Div(MessageImagesStyle.toModifier().toAttrs()) {
        images.forEachIndexed { index, url ->
            Img(src = url, alt = t.referenceImage(index + 1), attrs = MessageImageStyle.toModifier().toAttrs())
        }
    }
}

/**
 * Photos as small squares, each with a cross to take it out. The composer's waiting photos and
 * the ones an edit keeps are the same strip.
 */
@Composable
private fun AttachmentStrip(images: List<String>, labels: List<Int>, onRemove: (Int) -> Unit) {
    val t = LocalStrings.current.chat
    Div(AttachmentStripStyle.toModifier().toAttrs()) {
        images.forEachIndexed { index, url ->
            Div(AttachmentThumbStyle.toModifier().toAttrs()) {
                Img(
                    src = url,
                    alt = t.referenceImage(labels[index] + 1),
                    attrs = Modifier.styleModifier {
                        property("display", "block")
                        property("width", "100%")
                        property("height", "100%")
                        property("object-fit", "cover")
                        property("border-radius", "inherit")
                    }.toAttrs(),
                )
                Button(
                    onClick = { onRemove(index) },
                    modifier = Modifier.labelled(t.removeImage(labels[index] + 1)),
                    variant = AttachmentRemoveVariant,
                ) {
                    Glyph(Icons.Close, size = Tokens.iconSm.value())
                }
            }
        }
    }
}

/** An agent turn: who speaks, what they said, what it produced and what can be done with it. */
@Composable
private fun AgentTurn(message: ChatMessage, last: Boolean, onRetry: () -> Unit) {
    val t = LocalStrings.current

    Row(
        modifier = AgentHeaderStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(Space.Sm),
    ) {
        Box(AgentAvatarStyle.toModifier().attrsModifier { attr("aria-hidden", "true") }) {
            Glyph(Icons.Spark, size = Tokens.iconXs.value())
        }
        SpanText(t.chat.agentName, AgentNameStyle.toModifier())
        // A measured wait feels shorter and says what to expect next time.
        message.seconds?.let { SpanText(t.chat.worked(it)) }
    }

    RichText(message.text.withoutBlankRuns(), AgentMessageStyle.toModifier())

    // The one link the chat paints: this text is the product's, not the model's.
    if (message.tip) {
        A(
            href = KOFI_URL,
            attrs = TipInlineStyle.toModifier().toAttrs {
                target(ATarget.Blank)
                attr("rel", "noopener noreferrer")
            },
        ) {
            Text(t.chat.downloadedTip)
        }
    }

    message.artifact?.let { Receipt(it) }

    // A turn that produced nothing says so. Until it did, the only difference between failing
    // and succeeding was a missing copy button, which reads as nothing at all.
    if (message.noPage) {
        Box(NoticeStyle.toModifier().attrsModifier { attr("role", "status") }) {
            SpanText(t.chat.noPage)
        }
    }

    // Not under the download notice, which is the product speaking and not a turn, nor under a
    // reply still being written.
    if (message.tip || message.streaming) return

    // The agent's words are only copied: editing or deleting a turn is done from the request.
    MessageActions(message.text, editable = false, end = false, onEdit = {}, onDelete = null) {
        // The same button, and never the same word: after a page came out this asks for
        // another one, and "reintentar" would tell the person something went wrong.
        //
        // The word keys on [ChatMessage.noPage] and not on a missing receipt. A reopened
        // session rebuilds its messages from the API and no card comes back with them, so
        // "no card" there means "reloaded", not "failed" — and every turn of every session
        // anybody came back to would have been labelled a failure.
        if (last) {
            Action(
                text = if (message.noPage) t.chat.retry else t.chat.askAgain,
                title = if (message.noPage) t.chat.retryTitle else t.chat.askAgainTitle,
                onClick = onRetry,
            ) {
                Glyph(Icons.Retry, size = Tokens.iconXs.value())
            }
        }
    }
}

/**
 * Copy, edit and delete under a message. Edit and delete only once the server has the message and
 * nothing is being generated: the turn in flight already read the history they would change.
 *
 * Delete asks first, in place: it takes every later turn and its pages with it, and there is no
 * way back. The question stays in view without hover, since the answer is still pending.
 */
@Composable
private fun MessageActions(
    text: String,
    editable: Boolean,
    end: Boolean,
    onEdit: () -> Unit,
    onDelete: (() -> Unit)?,
    trailing: @Composable () -> Unit = {},
) {
    val t = LocalStrings.current.chat
    var copied by remember { mutableStateOf(false) }
    var confirming by remember { mutableStateOf(false) }

    if (confirming && editable && onDelete != null) {
        DeleteConfirm(onConfirm = { confirming = false; onDelete() }, onCancel = { confirming = false })
        return
    }

    LaunchedEffect(copied) {
        if (copied) {
            delay(COPIED_MILLIS)
            copied = false
        }
    }

    Div(
        MessageActionsStyle.toModifier()
            .thenIf(end, MessageActionsEndStyle.toModifier())
            .toAttrs(),
    ) {
        // "Ask again" first and always in view, so it never moves; the icons fade in beside it.
        trailing()
        Div({ attr("data-turn-icons", "") }) {
            IconAction(if (copied) t.copied else t.copy, if (copied) Icons.Check else Icons.Copy) {
                copyToClipboard(text) { ok -> copied = ok }
            }
            if (editable) {
                IconAction(t.editMessage, Icons.Pen, onEdit)
                if (onDelete != null) IconAction(t.deleteMessage, Icons.Trash) { confirming = true }
            }
        }
    }
}

/**
 * The question before a delete, built like the one for deleting a session so the two read as the
 * same act: what goes, what it takes with it, and the way out before the button that does it.
 */
@Composable
private fun DeleteConfirm(onConfirm: () -> Unit, onCancel: () -> Unit) {
    val t = LocalStrings.current

    Column(
        modifier = HistoryConfirmStyle.toModifier()
            .then(MessageConfirmStyle.toModifier())
            .attrsModifier {
                attr("role", "alertdialog")
                attr("aria-label", t.chat.deleteConfirmTitle)
                ref { element ->
                    revealWhole(element)
                    onDispose { }
                }
            },
        verticalArrangement = Arrangement.spacedBy(Space.Md),
    ) {
        Column {
            SpanText(t.chat.deleteConfirmTitle, HistoryConfirmTitleStyle.toModifier())
            SpanText(t.chat.deleteConfirmDetail, HistoryConfirmDetailStyle.toModifier())
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(Space.Sm),
        ) {
            Button(onClick = { onCancel() }, variant = HistoryCancelButtonVariant, size = ButtonSize.SM) {
                SpanText(t.history.cancel)
            }
            Button(onClick = { onConfirm() }, variant = HistoryConfirmButtonVariant, size = ButtonSize.SM) {
                SpanText(t.history.delete)
            }
        }
    }
}

/** How long the check replaces the copy icon: long enough to be seen, short enough to copy again. */
private const val COPIED_MILLIS = 1500L

@Composable
private fun IconAction(label: String, icon: String, onClick: () -> Unit) {
    Tooltip(label, side = TipSide.Top) {
        Button(
            onClick = { onClick() },
            modifier = Modifier.named(label),
            variant = MessageActionVariant,
        ) {
            Glyph(icon, size = Tokens.iconSm.value())
        }
    }
}

/**
 * The message being rewritten, in place of its bubble. Enter keeps it and Escape drops it, the
 * same keys as the composer, and the buttons are there for whoever does not use them. Saving is
 * offered only once there is something new to send: the same words would rewind for nothing.
 */
@Composable
private fun EditBubble(
    original: String,
    images: List<String>,
    onSave: (String, List<Int>) -> Unit,
    onCancel: () -> Unit,
) {
    val t = LocalStrings.current.chat
    var draft by remember { mutableStateOf(original) }
    // Positions in the saved message, which is how the server is told which to keep.
    var kept by remember { mutableStateOf(images.indices.toList()) }
    val changed = draft.isNotBlank() && (draft.trim() != original.trim() || kept.size != images.size)

    fun save() {
        if (changed) onSave(draft, kept) else onCancel()
    }

    Div(
        MessageEditBoxStyle.toModifier().toAttrs {
            ref { element ->
                revealWhole(element)
                onDispose { }
            }
        },
    ) {
        if (kept.isNotEmpty()) {
            AttachmentStrip(
                images = kept.map(images::get),
                labels = kept,
                onRemove = { index -> kept = kept.filterIndexed { i, _ -> i != index } },
            )
        }
        TextArea(
            value = draft,
            attrs = MessageEditFieldStyle.toModifier().toAttrs {
                attr("aria-label", t.editField)
                attr("rows", "3")
                ref { element ->
                    element.fitToContent()
                    element.focus()
                    element.setSelectionRange(element.value.length, element.value.length)
                    onDispose { }
                }
                onInput { event ->
                    draft = event.value
                    event.target.fitToContent()
                }
                onKeyDown { event ->
                    if (event.key == "Escape") {
                        onCancel()
                    } else if (event.key == "Enter" && !event.shiftKey && !event.isComposing) {
                        event.preventDefault()
                        save()
                    }
                }
            },
        )
        Div(MessageEditBarStyle.toModifier().toAttrs()) {
            Button(onClick = { onCancel() }, variant = MessageCancelVariant) {
                SpanText(t.cancelEdit)
            }
            Button(onClick = { save() }, variant = MessageSaveVariant, enabled = changed) {
                SpanText(t.saveEdit)
            }
        }
    }
    // Saving is not a quiet rewrite: it rewinds and asks again, and it says so before the click.
    SpanText(t.editHint, MessageEditHintStyle.toModifier())
}

/**
 * The turn's receipt: version, size and sections of the page produced.
 *
 * Everything comes from data already at hand; nothing is invented to fill the card.
 */
@Composable
private fun Receipt(card: ArtifactCard) {
    val t = LocalStrings.current

    Column(ArtifactCardStyle.toModifier()) {
        Row(
            modifier = ArtifactCardHeaderStyle.toModifier(),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            // Two sibling `Text` nodes would be one anonymous box and the `Spacer` would part nothing.
            SpanText(t.chat.version(card.label))
            Spacer()
            SpanText(t.chat.sizeInKb(card.sizeInBytes / BYTES_PER_KB))
        }
        card.sections.forEach { section ->
            Row(
                modifier = ArtifactCardRowStyle.toModifier(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                CheckIcon(
                    Modifier.size(Tokens.iconSm.value())
                        .color(Tokens.working.value())
                        .margin(right = Space.Md),
                )
                SpanText(section)
            }
        }
    }

    // Only under the first page of the session. Repeating it on every version would turn an
    // answer into noise, and by the second page nobody is asking the question any more.
    if (card.version == FIRST_VERSION) WhatNow()
}

/**
 * What to do with the page: the file is the page, the link only shows it.
 *
 * The second line is the important one. Without it somebody puts the link on their Instagram
 * and finds out months later that it was never their website.
 */
@Composable
private fun WhatNow() {
    val t = LocalStrings.current.chat

    Column(WhatNowStyle.toModifier()) {
        SpanText(t.whatNowTitle, WhatNowTitleStyle.toModifier())
        SpanText(t.whatNowDownload, WhatNowLineStyle.toModifier())
        SpanText(t.whatNowShare, WhatNowLineStyle.toModifier())
    }
}

/** The page a session starts from, and the only one the note above hangs under. */
private const val FIRST_VERSION = 1

/**
 * A quiet action button. The visible text and the `title` are separate parameters; deriving one
 * from the other yields labels that do not say what they do.
 */
@Composable
private fun Action(
    text: String,
    title: String,
    onClick: () -> Unit,
    icon: @Composable () -> Unit,
) {
    Button(
        onClick = { onClick() },
        modifier = Modifier.attrsModifier { attr("title", title) },
        variant = GhostButtonVariant,
        size = ButtonSize.SM,
    ) {
        icon()
        SpanText(text, Modifier.margin(left = Space.Sm))
    }
}

/**
 * What the agent is doing right now.
 *
 * A turn can take well over a minute; without this the screen looks broken. The text says what
 * is happening, and with a tool it says which one: "Consultando estructura" informs,
 * "Consultando sus instrucciones" three times in a row does not.
 */
@Composable
private fun ActivityIndicator(activity: Activity) {
    val t = LocalStrings.current.activity
    // The subject comes from the backend already validated, and it is a name: it is not translated.
    val line: Pair<String, String>? = when (activity) {
        Activity.Idle -> null
        Activity.Thinking -> Icons.Idea to t.thinking
        Activity.WritingPage -> Icons.Pen to t.writingPage
        Activity.Stopping -> Icons.Stop to t.stopping
        is Activity.InStage -> when (activity.stage) {
            TurnStage.PLANNING -> Icons.Idea to t.planning
            TurnStage.CHECKING -> Icons.Checklist to t.checkingPage
            TurnStage.REVIEWING -> Icons.Eye to t.reviewingDesign
            TurnStage.CORRECTING -> Icons.Wrench to t.correcting
            TurnStage.SAVING -> Icons.Save to t.saving
        }
        is Activity.UsingTool -> toolActivity(activity, t)
    }
    val (icon, text) = line ?: return

    Row(
        modifier = Modifier.margin(bottom = Space.Xl),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(Space.Sm),
    ) {
        // The icon repeats the text for the eye; to a screen reader the text is enough.
        Span(ActivityIconStyle.toModifier().toAttrs { attr("aria-hidden", "true") }) {
            Glyph(icon, size = Tokens.iconSm.value())
        }
        Span(ActivityStyle.toModifier().toAttrs { attr("aria-live", "polite") }) {
            Text(text)
            Span(ActivitySheenStyle.toModifier().toAttrs { attr("aria-hidden", "true") }) {
                Span(ActivitySheenTextStyle.toModifier().toAttrs()) { Text(text) }
            }
        }
    }
}

/** A tool at work, as an icon and a line: what it does, and on what when the backend says. */
private fun toolActivity(activity: Activity.UsingTool, t: ActivityStrings): Pair<String, String> {
    val subject = activity.subject?.replace('-', ' ')
    return when (activity.tool) {
        "load_skill", "read_skill_file" -> Icons.Book to (subject?.let(t::consultingSkill) ?: t.consultingInstructions)
        "buscar_imagen" -> Icons.Search to (subject?.let(t::searchingNamedPhotos) ?: t.searchingPhotos)
        "read_section" -> Icons.Eye to (subject?.let(t::readingNamedSection) ?: t.readingSection)
        "view_page" -> Icons.Eye to t.lookingAtPage
        "replace_section", "patch_section" ->
            Icons.Pen to (subject?.let(t::editingNamedSection) ?: t.editingSection)
        else -> Icons.Spark to t.working
    }
}

/**
 * The writing field, with the send button inside it.
 *
 * Enter sends and Shift+Enter breaks the line; the button exists anyway, because a shortcut
 * cannot be the only path. The same button stops the generation while it runs: that spot is
 * free and the hand is already there. It keeps the native tooltip instead of [Tooltip]: it sits
 * `position: absolute` anchored to `ComposerFieldStyle`, and the wrapper `Box` would move that
 * anchor.
 */
@Composable
private fun Composer(enabled: Boolean, onSend: (String, List<ImageUpload>) -> Unit, onCancel: () -> Unit) {
    val t = LocalStrings.current
    var draft by remember { mutableStateOf("") }
    var field by remember { mutableStateOf<HTMLTextAreaElement?>(null) }
    val scope = rememberCoroutineScope()
    val pending = remember(t) {
        PendingPhotos(scope, tooMany = t.chat.imagesLimit(MAX_REFERENCE_PHOTOS), unreadable = t.chat.imageUnreadable)
    }
    val sendable = enabled && draft.isNotBlank()
    val placeholder = composerPlaceholder()

    AutoGrow(field, draft)

    fun submit() {
        val text = draft.trim()
        if (text.isNotEmpty() && enabled) {
            onSend(text, pending.take())
            draft = ""
            // After a click the focus is on the button; the next thing anyone does is type.
            field?.focus()
        }
    }


    Div(ComposerStyle.toModifier().toAttrs { photoDropZone(enabled, pending::add) }) {
        PhotoTray(pending)
        Div(ComposerFieldStyle.toModifier().toAttrs()) {
            AttachButton(enabled, pending)
            TextArea(
                value = draft,
                attrs = ComposerInputStyle.toModifier().toAttrs {
                    // A `<textarea>` defaults to two rows, and that default is what made the
                    // composer look crooked: the box was always two lines tall with one line of
                    // text in it, so the send button -anchored to the bottom, where it belongs
                    // once the field grows- sat a row below the placeholder. One row is the
                    // floor; `fitToContent` takes it up from there.
                    attr("rows", "1")
                    attr("placeholder", placeholder)
                    // The placeholder disappears while typing; the accessible name does not.
                    attr("aria-label", t.chat.composerLabel)
                    if (!enabled) disabled()
                    ref { element ->
                        field = element
                        onDispose { field = null }
                    }
                    onInput { event ->
                        draft = event.value
                        // Resized here and not only from the effect: the effect runs after
                        // composition, so the box grew one frame after the letter appeared.
                        event.target.fitToContent()
                    }
                    photoPaste(pending::add)
                    onKeyDown { event ->
                        // `isComposing` is the whole reason this is not just a key check. With a
                        // Japanese, Chinese or Korean keyboard, Enter confirms the candidate word
                        // being composed; without the guard that keystroke sends the half-written
                        // message and clears the field, and the person never sees what happened.
                        if (event.key == "Enter" && !event.shiftKey && !event.isComposing) {
                            event.preventDefault()
                            submit()
                        }
                    }
                },
            )

            Button(
                onClick = { if (enabled) submit() else onCancel() },
                modifier = Modifier.labelled(if (enabled) t.chat.send else t.chat.stop),
                variant = if (enabled) SendButtonVariant else StopButtonVariant,
                // Nothing to send is a state the button should show, not one it should swallow:
                // it used to look ready with an empty field and do nothing when pressed.
                enabled = !enabled || sendable,
            ) {
                if (enabled) {
                    ArrowUpIcon(Modifier.size(Tokens.iconLg.value()))
                } else {
                    Glyph(Icons.Stop, size = Tokens.iconSm.value())
                }
            }
        }

        Row(
            modifier = ComposerHintStyle.toModifier(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(Space.Lg),
        ) {
            Shortcut(t.chat.enterKey, t.chat.enterHint)
            Shortcut(t.chat.newLineKey, t.chat.newLineHint)
        }
    }
}

/** The photos waiting to go, and why the last one was not taken if it was not. */
@Composable
private fun PhotoTray(pending: PendingPhotos) {
    if (pending.photos.isNotEmpty()) {
        AttachmentStrip(
            images = pending.photos.map { it.dataUrl() },
            labels = pending.photos.indices.toList(),
            onRemove = pending::remove,
        )
    }
    pending.error?.let { SpanText(it, AttachmentErrorStyle.toModifier()) }
}

/** A screenshot pasted into the field is attached; pasted text still goes into the field. */
private fun AttrsScope<HTMLTextAreaElement>.photoPaste(onFiles: (List<File>) -> Unit) {
    onPaste { event ->
        val files = event.clipboardData?.files.imageFiles()
        if (files.isNotEmpty()) {
            event.preventDefault()
            onFiles(files)
        }
    }
}

/** Photos dragged from the desktop onto the composer are attached like picked ones. */
private fun AttrsScope<HTMLDivElement>.photoDropZone(enabled: Boolean, onFiles: (List<File>) -> Unit) {
    onDragOver { event -> if (enabled) event.preventDefault() }
    onDrop { event ->
        val files = event.dataTransfer?.files.imageFiles()
        if (enabled && files.isNotEmpty()) {
            event.preventDefault()
            onFiles(files)
        }
    }
}

/** The example in the empty field, shorter on a phone so it fits on one line beside the buttons. */
@Composable
private fun composerPlaceholder(): String {
    val t = LocalStrings.current.chat
    return if (rememberNarrowScreen()) t.placeholderShort else t.placeholder
}

/**
 * The photo button, with the hidden file input it opens. The input is the only way a browser
 * lets a page ask for files; the button is what it looks like.
 */
@Composable
private fun AttachButton(enabled: Boolean, pending: PendingPhotos) {
    val t = LocalStrings.current
    var picker by remember { mutableStateOf<HTMLInputElement?>(null) }

    Input(InputType.File) {
        attr("accept", "image/jpeg,image/png,image/webp")
        attr("multiple", "")
        attr("hidden", "")
        ref { element ->
            picker = element
            onDispose { picker = null }
        }
        onChange { event ->
            pending.add(event.target.files.imageFiles())
            // Picking the same file twice in a row must fire again.
            event.target.value = ""
        }
    }
    Button(
        onClick = { picker?.click() },
        modifier = Modifier.labelled(t.chat.attachImages),
        variant = AttachButtonVariant,
        enabled = enabled && !pending.full,
    ) {
        Glyph(Icons.Photo, size = Tokens.iconMd.value())
    }
}


/**
 * Keeps the composer's height matched to what it holds and to how wide it currently is.
 *
* Three occasions, and each one covers a case the others miss: the effect below for a change no
 * keystroke announces - the field emptying after a send - `onInput` at the call site for typing,
 * where running from an effect alone leaves the growth a frame behind the letter that caused it,
 * and the observer for the column changing width.
 *
 * That last one was a real defect. The height was measured against a narrower panel, where the
 * placeholder wrapped onto a second line, and nothing remeasured it when the divider was dragged
 * open: the field kept two lines of height with one line of text in it, and the send button -
 * anchored to the bottom, as it should be - sat a row below the text. Only a width change is
 * acted on; reacting to the height this callback just set is how an observer chases its own tail.
 */
@Composable
private fun AutoGrow(field: HTMLTextAreaElement?, draft: String) {
    LaunchedEffect(draft, field) { field?.fitToContent() }

    DisposableEffect(field) {
        if (field == null) {
            onDispose { }
        } else {
            var lastWidth = field.clientWidth
            val observer = ResizeObserver {
                if (field.clientWidth != lastWidth) {
                    lastWidth = field.clientWidth
                    field.fitToContent()
                }
            }
            observer.observe(field)
            onDispose { observer.disconnect() }
        }
    }
}

@Composable
private fun Shortcut(key: String, meaning: String) {
    Row(
        modifier = ShortcutStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(Space.Sm),
    ) {
        SpanText(key, KbdStyle.toModifier())
        SpanText(meaning)
    }
}

/**
 * Fits the field's height to what its text takes up.
 *
 * The preceding `height = "auto"` is not optional: `scrollHeight` measures within the current
 * height, and without releasing it a field that grew would never shrink back. The cap comes
 * from the CSS `max-height`, not from this calculation.
 */
private fun HTMLTextAreaElement.fitToContent() {
    // Empty, its rows are the height: some browsers count a wrapped placeholder in `scrollHeight`.
    if (value.isEmpty()) {
        style.removeProperty("height")
        return
    }
    style.height = "auto"
    // `border-box` includes the padding in the height but not the border.
    style.height = "${scrollHeight + BORDER_PX}px"
}

/** The two pixels of the border, which `scrollHeight` does not count. */
private const val BORDER_PX = 2

/**
 * The model's prose with every run of blank lines cut down to one. It pads its paragraphs with
 * three or four, and in a bubble that paints as a hole in the middle of the answer.
 */
private fun String.withoutBlankRuns(): String = replace(BLANK_RUN, "\n\n").trim()

private val BLANK_RUN = Regex("\n[ \t]*(\n[ \t]*)+\n")

/**
 * Scrolls the thread just enough for [element] to be seen whole: a question or an editor opened
 * on a bubble near the bottom left its buttons below the fold. Waits a frame so the element has
 * its children and its height; a place already in view does not move at all.
 */
private fun revealWhole(element: Element) {
    window.requestAnimationFrame {
        element.scrollIntoView(
            ScrollIntoViewOptions(
                block = ScrollLogicalPosition.NEAREST,
                inline = ScrollLogicalPosition.NEAREST,
                behavior = if (prefersReducedMotion()) ScrollBehavior.AUTO else ScrollBehavior.SMOOTH,
            ),
        )
    }
}
